interface PaymentStatuses {
  proposed: string;
  draft: string;
  open: string;
  paid: string;
  void: string;
}

export const paymentStatuses: PaymentStatuses = {
  proposed: 'Proposed',
  draft: 'Draft',
  open: 'Open',
  paid: 'Paid',
  void: 'Void',
};
